import React from "react";
import { motion } from "framer-motion";

export const SectionLayout = ({
  textLeft,
  title,
  text,
  image,
  altText,
  button,
  bgImage,
  motionProps,
}) => {
  return (
    <section
      className={`relative ${bgImage ? "bg-cover bg-center" : ""} ${
        bgImage ? "min-h-screen" : "py-20"
      }`}
      style={bgImage ? { backgroundImage: `url(${bgImage})` } : {}}
    >
      <div className="container px-4 mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Text Section */}
        <motion.div
          whileInView={motionProps?.titleMotion?.whileInView}
          initial={motionProps?.titleMotion?.initial}
          animate={motionProps?.titleMotion?.animate}
          transition={motionProps?.titleMotion?.transition}
          className={`text-center md:text-left ${
            textLeft ? "md:order-1" : "md:order-2"
          }`}
          viewport={{ once: true, amount: 0.3 }} // Only trigger animation once
        >
          <h2 className="text-3xl text-stone-800 mb-6">{title}</h2>
          <motion.p
            whileInView={motionProps?.textMotion?.whileInView}
            initial={motionProps?.textMotion?.initial}
            animate={motionProps?.textMotion?.animate}
            transition={motionProps?.textMotion?.transition}
            className="text-lg text-stone-600 mb-6 leading-relaxed"
            viewport={{ once: true, amount: 0.3 }} // Only trigger animation once
          >
            {text}
          </motion.p>
          {button && (
            <motion.a
              href={button.link}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full md:w-auto inline-flex items-center justify-center py-3 px-8 rounded-full borderfont-aboreto  bg-stone-800 text-white hover:bg-white hover:text-stone-800 border-2 border-stone-800 transition-all duration-300 "
            >
              {button.text}
            </motion.a>
          )}
        </motion.div>

        {/* Image Section */}
        {image && (
          <motion.div
            whileInView={motionProps?.imageMotion?.whileInView}
            initial={motionProps?.imageMotion?.initial}
            animate={motionProps?.imageMotion?.animate}
            transition={motionProps?.imageMotion?.transition}
            className={`relative ${textLeft ? "md:order-2" : "md:order-1"}`}
            viewport={{ once: true, amount: 0.3 }} // Only trigger animation once
          >
            <img
              src={image}
              alt={altText}
              className="w-full h-auto rounded-lg shadow-2xl"
            />
          </motion.div>
        )}
      </div>
    </section>
  );
};
